<template>
  <h2>{{ title }}</h2>
  <Button @click="overWrite" label="リストを再生" />
  <SongCard v-for="id in songs" :key="id" :songId="id" />
  <router-link :to="{ name: 'List' }">
    <ListButton
      v-if="this.store.state.list.cursor < this.store.state.list.ids.length"
      icon="list"
    />
  </router-link>
</template>

<script>
import { defineComponent, ref } from "vue";
import SongCard from "@/components/SongCard.vue";
import { useStore } from "vuex";
import firebase from "../firebase/firebase";
import Button from "primevue/button";
import ListButton from "@/components/ListButton.vue";

export default defineComponent({
  name: "ListDetails",
  components: { SongCard, Button, ListButton },
  setup() {
    const store = useStore();
    return {
      store,
      songs: ref([]),
      title: ref(""),
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      firebase
        .firestore()
        .collection("list")
        .doc(this.$route.params.listId)
        .get()
        .then((doc) => {
          const tmp = doc.data();
          this.title = tmp.title;
          tmp.songs.forEach((id) => {
            this.songs.push(id);
          });
        })
        .catch((err) => {
          alert(err);
        });
    },
    overWrite() {
      console.log("overw");
      this.store.commit("setList", this.songs);
    },
  },
});
</script>
